import Footer from "../component/Footer";
import Header from "../component/Header";
import { Link, useLocation, useParams } from "react-router-dom";
import ScrollToTop from "../component/ScrollToTop";

export default function HomeBlog3() {
    const id = useLocation();
    console.log(id.state.id, "id");
    return (
        <>
            <ScrollToTop>
                <Header />
                <div className="breadcumb-wrapper style2 bg-smoke">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="breadcumb-content justify-content-center">
                                    <ul className="breadcumb-menu">
                                        <li>
                                            <a href="/">Home</a>
                                        </li>
                                        <li>
                                            <a href="blog">Blog</a>
                                        </li>
                                        <li>Why Shopify Still Leads the E-Commerce Race</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* blog-details-area */}
                <section className="blog__details-area space">
                    <div className="container">
                        <div className="blog__inner-wrap">
                            <div className="row justify-content-center">
                                <div className="col-70">
                                    <div className="blog__details-wrap">
                                        <div className="blog__details-thumb">
                                            <img src="./images/blog/blog_details01.jpg" alt="img" />
                                        </div>
                                        <div className="blog__details-content">
                                            <div className="blog-post-meta">
                                                <ul className="list-wrap">
                                                    <li>March 26, 2024</li>
                                                    <li>
                                                        <a href="blog.html">Branding</a>
                                                    </li>
                                                    <li>
                                                        <a href="blog.html">by Ashton Porter</a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <h2 className="title">Why Shopify Still Leads the E-Commerce Race</h2>
                                            <p>
                                                HopeFly Meta has helped dozens of brands launch and scale with Shopify—and it’s easy to see why.
                                            </p>
                                            <p>
                                                Shopify continues to be one of the most reliable platforms for e-commerce, blending ease of use with enterprise-grade power.
                                            </p>
                                            <p>
                                                From product pages to checkout flows, every part of the Shopify experience is designed to help businesses convert visitors into customers. This year’s updates, including AI product recommendations and crypto wallet payments, make it even more powerful.
                                            </p>
                                            <blockquote>
                                                <img
                                                    className="blockquote-icon"
                                                    src="./images/icon/quote.svg"
                                                    alt="img"
                                                />
                                                <p>
                                                    “We launched our Shopify store in under two weeks with HopeFly Meta. It’s fast, mobile-friendly, and we’ve already seen a lift in sales.
                                                </p>
                                            </blockquote>
                                            <p>— D2C Brand Owner</p>
                                            <p>
                                                Whether you’re just starting out or looking to migrate from another platform, Shopify provides everything from shipping tools to analytics—and it keeps getting better.
                                            </p>

                                            <div className="blog__details-inner">
                                                <div className="row align-items-center">
                                                    <div className="col-sm-6">
                                                        <div className="blog__details-inner-thumb">
                                                            <img
                                                                src="./images/blog/blog_details02.jpg"
                                                                alt="img"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <div className="blog__details-inner-thumb">
                                                            <img
                                                                src="./images/blog/blog_details03.jpg"
                                                                alt="img"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p>
                                                At HopeFly Meta , we take a strategic approach to store setup, ensuring both design and performance are optimized from day one.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="wrapper">
                    <div class="marquee marquee-wrap">
                        <div class="marquee_group">
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="/service">
                                        <i className="fas fa-star-of-life" />
                                        Business Branding
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Web Development
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Cloud-based Application
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        AI Solution
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Metaverse Solution
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Marketing and SEO
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Web Service
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        E-commerce Plugin
                                    </Link>
                                </h6>
                            </div>
                        </div>
                        <div aria-hidden="ture" class="marquee_group">
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="/service">
                                        <i className="fas fa-star-of-life" />
                                        Business Branding
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Web Development
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Cloud-based Application
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        AI Solution
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Metaverse Solution
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Marketing and SEO
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        Web Service
                                    </Link>
                                </h6>
                            </div>
                            <div className="inner">
                                <h6 className="item m-item m-0">
                                    <Link to="#">
                                        <i className="fas fa-star-of-life" />
                                        E-commerce Plugin
                                    </Link>
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </ScrollToTop>
        </>
    );
}
